import { render, staticRenderFns } from "./LocalizedDate.vue?vue&type=template&id=b1a31500&scoped=true&"
import script from "./LocalizedDate.vue?vue&type=script&lang=js&"
export * from "./LocalizedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a31500",
  null
  
)

export default component.exports